import React, { FC, useState, useEffect } from 'react'
import i18n from 'i18next'
import { IonContent, IonFooter, IonToast, IonSpinner } from '@ionic/react'
import payMobx, { ICard } from '@mobx/pay/pay.mobx'

interface IProps {
  onAuthorize?(card: ICard): void;
  onToken?(token: string): void;
  multiUse?: boolean;
}

const HeartlandTokenizer: FC<IProps> = ({ onAuthorize, onToken, multiUse }) => {
  const [loaded, setLoaded] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const [authorizing, setAuthorizing] = useState<boolean>(false)

  const auth = async (token: string, details: any) => {
    if (multiUse) {
      setAuthorizing(true)
      try {
        const newCard = await payMobx.authBankCard('HeartLandBankCard', token, details)
        onAuthorize && onAuthorize(newCard)
      } catch (e) {
        console.error('error auth card', e)
        setErrorMessage(e.message)
      } finally {
        setAuthorizing(false)
      }
    } else {
      onToken && onToken(token)
    }
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://api2.heartlandportico.com/SecureSubmit.v1/token/gp-1.0.1/globalpayments.js'
    script.onload = () => {
      const GlobalPayments = (window as any).GlobalPayments
      GlobalPayments.configure({ publicApiKey: payMobx.channelAccountMap.HeartLandBankCard.publicApiKey })

      const cardForm = GlobalPayments.ui.form({
        fields: {
          'card-number': {
            placeholder: '•••• •••• •••• ••••',
            target: '#credit-card-card-number'
          },
          'card-expiration': {
            placeholder: 'MM / YYYY',
            target: '#credit-card-card-expiration'
          },
          'card-cvv': {
            placeholder: '•••',
            target: '#credit-card-card-cvv'
          },
          'submit': {
            target: '#credit-card-submit',
            text: i18n.t('pay.confirmAddBankCardNoChinese'),
          }
        },
        styles: {
          'input': {
            'appearance': 'none',
            '-webkit-appearance': 'none',
            'border': '1px solid #e6e6e6',
            'color': '#333333',
            'font-size': '16px',
            'border-radius': '4px',
            'width': '100.0%',
            'padding': '10px',
            'margin-top': '0px',
            'box-sizing': 'border-box',
          },
          '#secure-payment-field.submit': {
            'appearance': 'none',
            '-webkit-appearance': 'none',
            'margin': '10px',
            'outline': 'none',
            'border': 'none',
            'border-radius': '999px',
            'width': 'calc(100% - 20px)',
            'height': '48px',
            'line-height': '48px',
            'font-size': '14px',
            'font-weight': '600',
            'background': 'linear-gradient(135deg,rgba(255,81,81,1) 0%,rgba(224,3,36,1) 100%)',
            'color': '#fff'
          }
        }
      })
      cardForm.on('token-success', (resp) => {
        console.debug('token-success', resp)
        if (resp.paymentReference) {
          auth(resp.paymentReference, resp.details)
        }
      })
      cardForm.on('token-error', (resp) => {
        console.debug('token-error', resp)
        if (resp.error && resp.reasons && resp.reasons.length > 0) {
          setErrorMessage(resp.reasons[0].message)
        }
      })
      cardForm.on('event', (event) => {
        console.debug('token-event', event)
      })
      cardForm.on('load', () => {
        setTimeout(() => {
          setLoaded(true)
        }, 100)
      })
    }
    document.body.appendChild(script)
  }, [])

  return (
    <>
      <IonToast
        position='top'
        color='danger'
        isOpen={!!errorMessage}
        onDidDismiss={() => setErrorMessage('')}
        message={errorMessage}
        duration={2000}
      />
      <IonContent className='heartland-tokenizer'>
        {!loaded && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.jumpToProcessorPage')}</div>
          </div>
        )}
        {authorizing && (
          <div className='loading-wrapper'>
            <IonSpinner />
            <div>{i18n.t('pay.authorizingCard')}</div>
          </div>
        )}
        <div id='heartland-tokenizer-form'>
          <label>{i18n.t('pay.cardNumber')}</label>
          <div id='credit-card-card-number' />
          <label>{i18n.t('pay.cardExpiration')}</label>
          <div id='credit-card-card-expiration' />
          <label>{i18n.t('pay.cardCvv')}</label>
          <div id='credit-card-card-cvv' />
        </div>
      </IonContent>
      <IonFooter className='heartland-tokenizer-footer' style={{ display: authorizing ? 'none' : 'block' }}>
        {loaded && <div className='processor-power-by'>{i18n.t('pay.powerByProcessor')}</div>}
        <div id='credit-card-submit' />
      </IonFooter>
    </>
  )
}

export default HeartlandTokenizer
